export const POPULAR_MOVIES_API =
  "https://api.themoviedb.org/3/movie/popular?api_key=6241e31f828487ad21497bc364be7041&language=en-US&page=";
export const POPULAR_TV_SHOWS_API =
  "https://api.themoviedb.org/3/tv/popular?api_key=6241e31f828487ad21497bc364be7041&language=en-US&page=";
export const TRENDING_MOVIES_API =
  "https://api.themoviedb.org/3/trending/movie/week?api_key=6241e31f828487ad21497bc364be7041";
export const CATEGORIES_MOVIES_API =
  "https://api.themoviedb.org/3/genre/movie/list?api_key=6241e31f828487ad21497bc364be7041&language=en-US";
export const ACTOR_MOVIES_API =
  "https://api.themoviedb.org/3/credit/580489?api_key=6241e31f828487ad21497bc364be7041";
